import axios from 'axios';
import 'element-closest';

const updateButtonAndDescription = function(trigger, meta) {
  const triggerEl = trigger;
  const metaInfoEl = triggerEl
    .closest('.js-results-tools')
    .querySelector('.js-meta-info');
  const one = 1;
  let remainder;
  let resultsDisplaying;

  if (meta.pagination.current_page < meta.pagination.total_pages - one) {
    remainder = meta.pagination.per_page;
  } else {
    remainder =
      meta.pagination.total % meta.pagination.per_page === 0
        ? meta.pagination.per_page
        : meta.pagination.total % meta.pagination.per_page;
  }

  if (meta.pagination.current_page < meta.pagination.total_pages) {
    resultsDisplaying = meta.pagination.per_page * meta.pagination.current_page;
  } else {
    resultsDisplaying = meta.pagination.total;
  }

  if (meta.pagination.links.next === undefined) {
    triggerEl.remove();
  } else {
    triggerEl.text = `Load ${remainder} more results`;
    triggerEl.href = meta.pagination.links.next;
  }

  metaInfoEl.innerHTML = `Showing ${resultsDisplaying} of ${
    meta.pagination.total
  }`;
};

const insertCards = function(card, container) {
  container.insertAdjacentHTML('beforeend', card.html);
};

const clickEvent = function(event) {
  event.preventDefault();

  const trigger = event.target;
  const container = document.querySelector(
    trigger.getAttribute('data-container'),
  );

  axios.get(trigger.href).then(response => {
    const { data } = response.data;

    updateButtonAndDescription(trigger, response.data.meta);

    for (let i = 0; i < data.length; i += 1) {
      insertCards(data[i], container);
    }
  });
};

const loadMoreSearchResults = function() {
  const triggers = document.querySelectorAll('.js-load-more');

  for (let i = 0; i < triggers.length; i += 1) {
    triggers[i].addEventListener('click', clickEvent);
  }
};

export default loadMoreSearchResults;



// WEBPACK FOOTER //
// ./src/scripts/modules/load-more-search-results.js